import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    search: {
      borderColor: theme.palette.neutralTertiary,
      ':hover': {
        borderColor: theme.palette.neutralSecondary,
      },
    },
    callout: {
      width: 370,
    },
    searchAreaContainer: {
      overflow: 'hidden',
      padding: 20,
      backgroundColor: theme.palette.neutralLighterAlt,
    },
    resultItem: {
      textDecoration: 'none',
      margin: '0px -20px',
      padding: '6px 20px',
      ':hover': {
        backgroundColor: theme.palette.neutralLighter,
      },
      ':active': {
        backgroundColor: theme.palette.neutralLighter,
      },
    },
  };
});
